import { useMemo } from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { RateCard } from "@rebuild/shared";

interface RateCardSelectProps {
  rateCards: RateCard[];
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  isLoading?: boolean;
  hasError?: boolean;
}

export const RateCardSelect = ({ rateCards, value, onChange, isLoading, hasError }: RateCardSelectProps) => {
  const activeRateCards = useMemo(() => rateCards.filter((card) => !card.deleted), [rateCards]);

  return (
    <div className="flex flex-col items-start gap-1">
      <Label>Rate Card</Label>
      <div className="w-56">
        <Select value={value ?? ""} onValueChange={(next) => onChange(next || undefined)} disabled={isLoading}>
          <SelectTrigger className={hasError ? "border-destructive focus:ring-destructive" : undefined}>
            <SelectValue placeholder={isLoading ? "Loading..." : "Select a rate card"} />
          </SelectTrigger>
          <SelectContent>
            {activeRateCards.map((card) => (
              <SelectItem key={card.id} value={card.id}>
                {card.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {hasError && <p className="text-xs text-destructive">Rate card is required for Time and Material estimates</p>}
    </div>
  );
};
